import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";

import userReducer from './user.reducer';
import viewReducer from "./view.reducer";

const createRootReducer = (history) => combineReducers({
    router: connectRouter(history),
    user: userReducer,
    view: viewReducer
});

export default createRootReducer;